import { networkClient } from './client';
import type { ApiEnvelope } from './types';
import type { BETeamSubstitutionMetadata } from './teams';

export interface SubstitutionEligibility {
  canApply: boolean;
  substitutionsUsed: number;
  substitutionsRemaining: number;
  maxSubstitutions: number;
  alreadyUsedThisMatchday: boolean;
  periodType?: 'matchday' | 'gameweek';
  hasBoosterActive: boolean;
  eligibleSubOutPlayerIds: string[];
  eligibleSubInPlayerIds: string[];
  reasons: string[];
  latestMatchKickoffAt: string | null;
  availableSubstitutionBudget: number | null;
}

export interface SubstitutionHistoryItem {
  id: string;
  teamId: string;
  matchdayId: string | null;
  gameweekId: string | null;
  subOutPlayerId: string;
  subInPlayerId: string;
  updatedFormation: string | null;
  metadata?: BETeamSubstitutionMetadata | null;
  viceCaptainDisabled: boolean;
  appliedAt: string;
  isReverted: boolean;
  revertedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SubstitutionHistory {
  substitutionsUsed: number;
  substitutionsRemaining: number;
  items: SubstitutionHistoryItem[];
}

export interface GetSubstitutionEligibilityParams {
  teamId: string;
  matchdayId?: string;
  gameweekId?: string;
}

export interface ApplySubstitutionPayload {
  teamId: string;
  matchdayId?: string;
  gameweekId?: string;
  subOutPlayerId: string;
  subInPlayerId: string;
  formation: string;
  players: Array<{
    fantasyPlayerId: string;
    positionSlot: number;
  }>;
}

export interface ApplySubstitutionResult {
  substitution: SubstitutionHistoryItem;
  substitutionsUsed: number;
  substitutionsRemaining: number;
}

export interface GetSubstitutionHistoryParams {
  teamId: string;
}

export type SubstitutionEligibilityResponse = ApiEnvelope<SubstitutionEligibility>;
export type ApplySubstitutionResponse = ApiEnvelope<ApplySubstitutionResult>;
export type SubstitutionHistoryResponse = ApiEnvelope<SubstitutionHistory>;

export const getSubstitutionEligibility = (
  params: GetSubstitutionEligibilityParams
): Promise<SubstitutionEligibilityResponse> => {
  return networkClient
    .get<SubstitutionEligibilityResponse>('/api/substitutions/eligibility', { params })
    .then(({ data }) => data);
};

export const applySubstitution = (
  payload: ApplySubstitutionPayload
): Promise<ApplySubstitutionResponse> => {
  return networkClient
    .post<ApplySubstitutionResponse>('/api/substitutions/apply', payload)
    .then(({ data }) => data);
};

export const getSubstitutionHistory = (
  params: GetSubstitutionHistoryParams
): Promise<SubstitutionHistoryResponse> => {
  return networkClient
    .get<SubstitutionHistoryResponse>('/api/substitutions/history', { params })
    .then(({ data }) => data);
};
